module.exports = __webpack_public_path__ + "img/cn_tip.de7c3e65.png";